import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sessions: {
        data: [],
        page: 1,
        page_size: 10,
        totalPage: 1,
        status: 1,
        search: "",
        short_by: "",
        sort_order: "",
        loading: true
    },
    lots: {
        data: [],
        page: 1,
        page_size: 10,
        totalPage: 1,
        search: "",
        loading: true
    },
    selectedSession: null,
    selectedLot: null,
    deposit_amount: 0,
    bidding_limit: 0,
    bid_transaction_id:null
};

export const liveAuctionSlice = createSlice({
    name: "liveAuction",
    initialState,
    reducers: {
        handleLiveAuctionData: (state, action) => {
            if (action.payload.sessions) {
                const incoming = action.payload.sessions;

                state.sessions = {
                    ...state.sessions,
                    ...incoming,
                    ...("data" in incoming && {
                        data:
                            incoming.page === 1
                                ? incoming.data
                                : [...state.sessions.data, ...incoming.data]
                    }),
                    loading: incoming.loading ?? false,
                };
            }

            if (action.payload.lots) {
                const incoming = action.payload.lots;

                state.lots = {
                    ...state.lots,
                    ...incoming,
                    // ...("data" in incoming && {
                    //     data:
                    //         incoming.page === 1
                    //             ? incoming.data
                    //             : [...state.lots.data, ...incoming.data]
                    // }),
                    loading: incoming.loading ?? false,
                };
            }
        },
        handleSelection: (state, action) => {
            if ("selectedSession" in action.payload) {

                state.selectedSession = {
                    ...action.payload.selectedSession,
                };
            }

            if ("selectedLot" in action.payload) {

                state.selectedLot = {
                    ...action.payload.selectedLot,
                };
            }
            if ("deposit_amount" in action.payload) {

                state.deposit_amount = action.payload.deposit_amount

            }

            if ("bidding_limit" in action.payload) {
                state.bidding_limit = action.payload.bidding_limit
            }

              if ("bid_transaction_id" in action.payload) {
                state.bid_transaction_id = action.payload.bid_transaction_id
            }

        },
        clearLots: (state) => {
            state.lots = { ...initialState.lots };
        },

    },
});
export const { handleLiveAuctionData, clearLots, handleSelection } =
    liveAuctionSlice.actions;
export default liveAuctionSlice;
